module.exports = __webpack_public_path__ + "img/green.fdaa7c54.jpg";